import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { mapPermissionsToProps } from 'mappers/v1/permissions';
import { logout } from 'store/v1/authentication/actions';

const mapStateToProps = ({ profile, people }) => {
  const peopleLoading = people.loading;
  return {
    profile,
    peopleLoading,
    title: profile && profile.company && profile.company.name,
    ...mapPermissionsToProps({ profile }),
  };
};

const mapDispatchToProps = { logout };

const Index = (Component) => withRouter(connect(mapStateToProps, mapDispatchToProps)(Component));

export default Index;
